import React from 'react';
import { Col } from 'antd';
import moment from 'moment';
import { I18n } from '@aws-amplify/core';

import { useLibertyMutualSubStepsContext } from '../../../context';
import { Topic, Value } from '../styles';

export const AssessmentDate = () => {
	const {
		libertyMutualResult: {
			informations: { assessment_date }
		}
	} = useLibertyMutualSubStepsContext();

	return (
		<Col xs={24}>
			<Topic>{I18n.get('Assessment date')}:</Topic>
			<Value>{moment(assessment_date).format('L')}</Value>
		</Col>
	);
};
